<div class="container card fixed-min">
  <!-- p1 -->
  <div class="card-title">
    <div class="row align-items-center">
      <div class="col-8 my-0">
        <div class="d-flex align-items-center mx-2 mt-2">
          <h2>Filtros:</h2>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 mt-2">
        <div class="d-flex align-items-end justify-content-end mx-3"></div>
      </div>
    </div>
  </div>
  <hr class="my-0" />
  <!-- p2 -->
  <div class="card-body">
    <div class="row">
      <!-- Date selector from date -->
      <div class="col-lg col-sm-12">
        <div class="row">
          <label
            for="fromDatePicker"
            class="form-label title-blue-bimbo-cap mx-2"
            >Desde:
            {{
              getStartDateSelected
                | date: "EEEE dd-MMMM-yyyy" : "" : "es-mx"
                | titlecase
            }}</label
          >
          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              name="dp"
              ngbDatepicker
              [(ngModel)]="startDate"
              id="fromDatePicker"
              #d1="ngbDatepicker" />
            <button
              class="btn-outline-secondary"
              (click)="d1.toggle()"
              type="button">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- date selector to date -->
      <div class="col-lg col-sm-12">
        <div class="row">
          <label
            for="toDate"
            class="form-label title-blue-bimbo-cap mt-lg-0 mt-sm-1 mx-2"
            >Hasta:
            {{
              getEndDateSelected
                | date: "EEEE dd-MMMM-yyyy" : "" : "es-mx"
                | titlecase
            }}</label
          >
          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              name="toDate"
              ngbDatepicker
              [(ngModel)]="endDate"
              id="toDate"
              #d2="ngbDatepicker" />
            <button
              class="btn-outline-secondary"
              (click)="d2.toggle()"
              type="button">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- search btn -->
      <div
        class="col-lg-1 col-sm-12 row align-items-center justify-content-center mt-2"
        style="min-width: 49px">
        <button
          mat-mini-fab
          color="primary"
          (click)="onChangeFilterSearch()"
          [disabled]="isLoadingTableData">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
    <div class="row col-12">
      <span class="form-text text-danger" *ngIf="getShowDatesError">
        Por favor, asegúrese de ingresar ambas fechas y que la fecha de inicio
        sea anterior a la fecha de fin.
      </span>
    </div>
    <!-- Filters -->
    <div *ngIf="isLoadingTableData" class="d-flex justify-content-center">
      <ng-container>
        <span
          class="spinner-border spinner-border-sm mt-5"
          style="margin-right: 10px"
          role="status"
          aria-hidden="true"></span>
      </ng-container>
    </div>
    <div id="filters-div" *ngIf="!isLoadingTableData">
      <!-- R1 -->
      <div class="row mb-3 align-content-center">
        <!-- search bar -->
        <div class="col-10 mt-3">
          <label for="sessionName" class="form-label title-blue-bimbo-cap mx-2"
            >Buscar Sesi&oacute;n:</label
          >
          <input
            type="text"
            name="sessionName"
            id="searchNameInput"
            placeholder="Buscar por nombre de la sesi&oacute;n, o ID localizador"
            class="form-control"
            [(ngModel)]="textSearch"
            (change)="onChangeFilterSearch()" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4 card">
  <!-- spinner -->
  <ng-container *ngIf="isLoadingTableData; else showTable">
    <app-loading-spinner></app-loading-spinner>
  </ng-container>
  <!-- table and no data -->
  <ng-template #showTable>
    <!-- table -->
    <ng-container *ngIf="sessionsList.length > 0; else noData">
      <app-my-qrs-catalog [sessions]="sessionsList"></app-my-qrs-catalog>
      <!-- Paginación -->
      <div class="d-flex justify-content-end p-2">
        <ngb-pagination
          [collectionSize]="collectionSize"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true"
          (pageChange)="getQrList()">
        </ngb-pagination>
        <select
          class="form-select mx-5"
          style="width: auto"
          [(ngModel)]="pageSize"
          (change)="onChangeFilterSearch()">
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>
    </ng-container>
    <!-- no data and error msg -->
    <ng-template #noData>
      <div
        class="d-flex flex-column align-items-center mb-2 mt-3 text-center"
        *ngIf="errorOccurred">
        <div>
          <h3 class="form-text text-danger mt-3">
            Ha ocurrido un error al cargar los datos
          </h3>
          <h4 (click)="reloadPage()" style="cursor: pointer">
            Da click aqu&iacute; para volver a intentar
          </h4>
        </div>
      </div>
      <app-no-data-msg message="No hay QRs para mostrar"></app-no-data-msg>
    </ng-template>
  </ng-template>
</div>
